<!--
 * @Description: 
 * @Author: xiaoyao
 * @since: 2020-06-16 15:08:38
 * @LastAuthor: @yangwenshan
 * @lastTime: 2021-10-14 17:13:52
--> 
<template>
  <div class="logo">
    <router-link :to="{name:'Workplace'}">
      <img src="/static/img/logo1.jpg" class="cutom" alt="logo">
      <h1 v-if="showTitle">{{ title }}</h1>
    </router-link>
  </div>
</template>

<script>
  export default {
    name: 'Logo',
    props: {
      title: {
        type: String,
        default: '平安行车险',
        required: false
      },
      showTitle: {
        type: Boolean,
        default: true,
        required: false
      }
    }
  }
</script>

<style lang="less" scoped>
.logo {
  .cutom{
    height: 44px;
    width: auto;
    border-style: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Tools/Logo.vue